import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import RenderTextField from "../inputs/renderTextField";
import PersonFormValidation from "../validation/forms/personFormValidator";
import Button from '@material-ui/core/Button';

const PillarForm =  (props) =>{
  const {submitPillar, handleSubmit, pillar, handleCancel} = props;
  return (
    <form onSubmit={handleSubmit(submitPillar)}>
      <div className={'form-group'}>
        <Field name="name" label={'Name'} component={RenderTextField} type="text" required fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field  min={"0"} step={"0.1"} name="weightOld" label={'Εξάμηνη βαρύτητα'} component={RenderTextField} type="number" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field  min={"0"} step={"0.1"} name="weightNew" label={'Βαρύτητα νέων καταστημάτων'} component={RenderTextField} type="number" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field  min={"0"} step={"0.1"} name="weightNewComing" label={'Βαρύτητα υφιστάμενων καταστημάτων'} component={RenderTextField} type="number" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Button type={'submit'} variant="contained" color="primary" className={'mr-3'}>
          {pillar.id?'Edit':'Create'}
        </Button>
        <Button onClick={handleCancel} variant="contained" color="secondary">
          {'Cancel'}
        </Button>
      </div>
    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'pillar',
  validate: PersonFormValidation,
})(PillarForm);



// WEBPACK FOOTER //
// ./src/components/pillar/pillarForm.js